import React from "react";
import { createPortal } from "react-dom";
import { cn } from "@/lib/utils";

export const DEFAULT_ERROR_COPY = "Error Occurred";

export interface ErrorViewProps {
  code?: string | number;
  title?: string;
  children?: React.ReactNode;
  className?: string;
}

const ErrorView: React.FC<ErrorViewProps> = ({
  code,
  title = DEFAULT_ERROR_COPY,
  children,
  className,
}) => {
  const showCode = code != null && code !== "";
  const wordmark =
    showCode && typeof document !== "undefined"
      ? createPortal(
          <div
            data-testid="error-code-wordmark"
            aria-hidden
            className="pointer-events-none fixed inset-0 z-0 overflow-hidden"
          >
            <span
              className={cn(
                "absolute bottom-0 right-0 select-none font-black leading-none tracking-tighter",
                "translate-x-[12%] translate-y-[28%] text-[min(52vw,42vh)] text-primary/15"
              )}
            >
              {code}
            </span>
          </div>,
          document.body
        )
      : null;

  return (
    <div data-testid="error-view" className={cn("relative z-10", className)}>
      {wordmark}
      <div className="relative z-10 space-y-3">
        <h1 className="text-2xl font-bold tracking-tight text-foreground">{title}</h1>
        {children}
      </div>
    </div>
  );
};

export default ErrorView;
